<template>
  <section id="user-list">
    <b-card>
      <b-card-body>
        <b-button
          variant="gradient-success"
          @click="showModal()"
        >
          اضافه کردن پرسنل
        </b-button>
        <v-data-table
          :headers="headers"
          :items="desserts"
          :items-per-page="40"
        >
          <template v-slot:item.actions="{ item }">
            <v-icon
              v-if="!item.admin"
              @click="onEditItem(item)"
            >
              mdi-circle-edit-outline
            </v-icon>
            <v-icon
              v-if="!item.admin"
              small
              @click="deleteItem(item)"
            >
              mdi-delete
            </v-icon>
          </template>
          <template v-slot:no-data>
            <v-btn
              variant="gradient-success"
              @click="initialize"
            >
              بروزرسانی
            </v-btn>
          </template>
        </v-data-table>

        <!-- modal login-->
        <b-modal
          ref="modal-add"
          cancel-variant="outline-secondary"
          ok-title="افزودن"
          cancel-title="بستن"
          centered
          title="کارمند جدید"
        >
          <validation-observer ref="Validation">
            <b-form>
              <!-- title -->
              <b-form-group
                label="نام"
                label-for="vi-fName"
              >
                <validation-provider
                  #default="{ errors }"
                  name="نام"
                  rules="required"
                >
                  <b-input-group class="input-group-merge">
                    <b-input-group-prepend is-text>
                      <feather-icon icon="UserIcon" />
                    </b-input-group-prepend>
                    <b-form-input
                      id="vi-fName"
                      v-model="fName"
                      placeholder=""
                    />
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- پروتکل -->
              <b-form-group
                label="نام خانوادگی"
                label-for="vi-lName"
              >
                <validation-provider
                  #default="{ errors }"
                  name="فیلد نام خانوادگی"
                  rules="required"
                >
                  <b-input-group class="input-group-merge">
                    <b-input-group-prepend is-text>
                      <feather-icon icon="UserIcon" />
                    </b-input-group-prepend>
                    <b-form-input
                      id="vi-lName"
                      v-model="lName"
                      placeholder=""
                    />
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- port -->
              <b-form-group
                label="شماره همراه"
                label-for="vi-mobile"
              >
                <validation-provider
                  #default="{ errors }"
                  name="فیلد شماره همراه"
                  rules="required"
                >
                  <b-input-group class="input-group-merge">
                    <b-input-group-prepend is-text>
                      <feather-icon icon="UserIcon" />
                    </b-input-group-prepend>
                    <b-form-input
                      id="vi-mobile"
                      v-model="mobile"
                      v-on:keyup="mobileChangeEn($event)"
                      placeholder="09XXXXXXXXX"
                    />
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group
                label="نقش"
                label-for="vi-rel"
              >
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon icon="UserIcon" />
                  </b-input-group-prepend>
                  <b-form-select
                    v-model="rel"
                    required
                  >
                    <option
                      selected
                      disabled
                      value=""
                    >
                      انتخاب کنید
                    </option>
                    <option
                      v-for="item in relList"
                      :value="item.code"
                      :disabled= "item.disabled"
                    >
                      {{ item.title }}
                    </option>
                  </b-form-select>
                </b-input-group>
              </b-form-group>
              <b-form-group>
                <b-form-checkbox
                    id="active"
                    v-model="active"
                    value="true"
                >
                  فعال شدن حضور و غیاب
                </b-form-checkbox>
              </b-form-group>

            </b-form>
          </validation-observer>
          <template #modal-footer="">
            <b-button
              size="sm"
              variant="danger"
              @click="hideModal"
            >
              بستن
            </b-button>
            <b-button
              size="sm"
              variant="success"
              @click="modalOk()"
            >
              ذخیره
            </b-button>
          </template>
        </b-modal>
      </b-card-body>
    </b-card>

  </section>

</template>
<script>
import {
  BCard, BCardBody, BModal, BButton, BInputGroup, BInputGroupPrepend, BFormGroup, BFormInput, BFormSelect, BForm, BFormCheckbox,
} from 'bootstrap-vue'
// eslint-disable-next-line import/extensions
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import Vue from 'vue'
import router from '@/router'
import userService from '@/services/user.service'
import { func } from '@/func'

Vue.prototype.$functions = func
export default {
  components: {
    BCard,
    BCardBody,
    BButton,
    BModal,
    BInputGroup,
    BInputGroupPrepend,
    BFormGroup,
    BFormInput,
    BForm,
    BFormSelect,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      desserts: [],
      relList: [{ code: 1, title: 'سازنده', disabled: true }, { code: 3, title: 'مدیر', disabled: false }, { code: 2, title: 'کارمند', disabled: false }],
      id: null,
      fName: null,
      lName: null,
      mobile: null,
      active: true,
      rel: null,
      required,
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'نام',
          align: 'start',
          sortable: false,
          value: 'fName',
        },
        { text: 'نام خانوادگی', value: 'lName' },
        { text: 'شماره همراه', value: 'userId.mobile' },
        { text: 'نقش', value: 'role' },
        { text: 'عملیات', value: 'actions', sortable: false },
      ]
    },
  },
  async created() {
    this.initialize()
  },
  mutations: {
    deleteItem(state, payload) {
      state.items.splice(payload, 1)
      // eslint-disable-next-line no-underscore-dangle
    },
  },
  methods: {
    initialize() {
      const companySelected = localStorage.getItem('companySelected')
      if (companySelected === undefined) {
        setTimeout(this.initialize, 2000)
      }
      this.desserts = []
      userService.getList({ companyId: localStorage.getItem('companySelected') }).then(
        res => {
          if (res.status === 'success') {
            if ('result' in res && 'data' in res.result && res.result.data.length > 0) {
              for (let i = 0; i <= res.result.data.length - 1; i++) {
                console.log(res.result.data[i].active)
                if(typeof res.result.data[i].active === 'undefined')
                  res.result.data[i].active = true

                if (res.result.data[i].rel === 1) {
                  res.result.data[i].role = 'سازنده'
                  res.result.data[i].admin = true
                }
                if (res.result.data[i].rel === 2) {
                  res.result.data[i].role = 'کارمند'
                }
                if (res.result.data[i].rel === 3) {
                  res.result.data[i].role = 'مدیر'
                }
                this.desserts.push(res.result.data[i])
              }
            }
          }
        },
        error => {
          this.message = (error.response && error.response.data)
                || error.message
                || error.toString()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'register error',
              text: this.message,
              icon: 'XIcon',
              variant: 'danger',
            },
          })
        },
      )
    },
    addClick() {
      router.push({ path: '/user/add' })
    },
    modalOk() {
      this.locale = 'fa'
      this.$refs.Validation.validate().then(success => {
        if (success) {
          userService.addPersonal({
            _id: this.id,
            companyId: localStorage.getItem('companySelected'),
            fName: this.fName,
            lName: this.lName,
            mobile: this.mobile,
            active: this.active,
            rel: this.rel,
          }).then(
            res => {
              if (res.status === 'success') {
                this.initialize()
                this.hideModal()
              }
            },
            error => {
              this.message = (error.response && error.response.data)
                    || error.message
                    || error.toString()
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'خطا',
                  text: this.message,
                  icon: 'XIcon',
                  variant: 'danger',
                },
              })
            },
          )
        }
      })
    },
    deleteItem(item) {
      let index = this.desserts.indexOf(item)
      // eslint-disable-next-line no-restricted-globals,no-unused-expressions
      if (confirm('Are you sure you want to delete this item?')) {
        userService.delete({
          // eslint-disable-next-line no-underscore-dangle
          userId: this.desserts[index]._id,
          companyId: localStorage.getItem('companySelected'),
        }).then(
          res => {
            if (res.status !== 'success') {
              alert(JSON.stringify((res)))
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'register error',
                  text: res.result,
                  icon: 'XIcon',
                  variant: 'danger',
                },
              })
            } else {
              this.desserts.splice(index, 1)
            }
          },
          error => {
            this.message = (error.response && error.response.data)
                  || error.message
                  || error.toString()
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'register error',
                text: this.message,
                icon: 'XIcon',
                variant: 'danger',
              },
            })
          },
        )
      } else {
        index = ''
      }
      // Todo: Make this delete item from store
      // eslint-disable-next-line no-underscore-dangle
    },
    onEditItem(item) {
      const index = this.desserts.indexOf(item)
      // eslint-disable-next-line no-underscore-dangle
      this.id = this.desserts[index]._id.toString()
      this.fName = this.desserts[index].fName.toString()
      this.lName = this.desserts[index].lName.toString()
      this.mobile = this.desserts[index].userId.mobile.toString()
      this.active = this.desserts[index].active
      this.rel = this.desserts[index].rel.toString()

      this.$refs['modal-add'].show()
    },
    showModal() {
      this.id = null
      this.fName = null
      this.lName = null
      this.mobile = null
      this.active = null
      this.rel = null

      //  this.initializeOption()
      this.$refs['modal-add'].show()
    },
    hideModal() {
      this.$refs['modal-add'].hide()
    },
    mobileChangeEn(event) {
      this.mobile = this.$functions.fixNumbers(event.target.value)
    },
  },
}
</script>
<style>
#user-list table thead tr {
  background: #f4f4f2;
}
#user-list table thead tr th{
  font-size: 1rem;
  color: azure;
  font-size: 0.9rem;
  color: #2b2b2b;
  font-weight: bold;
}
</style>
